<template>
  <div
    class="rating-wrapper"
    :style="{ 'justify-content': justify }">
    <v-rating
      v-model="rating"
      :readonly="!editable"
      :background-color="backgroundColor"
      :color="color"
      :size="size"
      dense
      half-increments
      @input="onValueInput" />

    <slot name="label">
      <span v-if="count || count === 0">({{ count }})</span>
    </slot>
  </div>

</template>

<script>
export default {
  name: 'StarRating',
  props: {
    rating: Number,
    order: Number,
    variable: String,
    backgroundColor: {
      type: String,
      default: '#F3C036',
    },
    color: {
      type: String,
      default: '#F3C036',
    },
    size: {
      type: Number,
      default: 24,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    count: {
      type: Number,
    },
    justify: {
      type: String,
      default: 'center',
    },
    change: Function,
  },
  methods: {
    onValueInput (ratingValue) {
      this.$emit('change', { ratingValue, order: this.order, variable: this.variable })
    },
  },
}
</script>

<style lang="scss">
.rating-wrapper {
  display: flex;
  align-items: center;

  color: inherit;
  font-family: "Avenir Medium", sans-serif;
  font-size: 16px;
  line-height: 18px;

}
.v-rating .v-icon {
  padding: 0 !important;
}
</style>
